import userActions from 'store/user/actions';
import { GET_PREFERENCES_SUCCESS } from '../../actions/getPreferences/getPreferences';


const allPreferences = (state = [], action) => {
  switch (action.type) {
    case GET_PREFERENCES_SUCCESS:
      return action.preferences;
    case userActions.LOGOUT_SUCCESS:
      return [];
    default:
      return state;
  }
};

export default allPreferences;
